/**
 * brand.js — Single source of truth for Voices of River History site identity.
 *
 * ⚠️  SYMLINK WARNING: This file is symlinked into AdminClient/src/config/brand.js
 * so the frontend can import it within CRA's src/ boundary. There is only ONE
 * file — edits here are immediately visible to both backend and frontend.
 * Do NOT copy this file. Do NOT edit the symlink target directly.
 * If the symlink breaks (git clone, rsync, backup restore), recreate it
 * from the project root:
 *   ln -s ../../../config/brand.js AdminClient/src/brand/brand.js
 *             ^-- source (this file)   ^-- symlink location
 *
 * Consumed by: AdminServer (mailer.js), AdminClient (Navigation, Homepage, index.html).
 * CSS-specific brand values (colors) live alongside this file in brand/brand.css.
 *
 * NOT for dynamic/generated content (project name variants, location,
 * homepage flavor text) — those live in randomUtils.js.
 */

const brand = {
  // ─── Site Identity ──────────────────────────────────────────────────────────

  name: 'Voices of River History',
  // First-draft copy — adapted from peoplesriverhistory.org's own framing.
  // Review before treating as final.
  tagline: 'Stories Carried Downstream',

  // Short description (meta name="description", twitter:description)
  descriptionShort: 'An audio stream of river voices and oral history from America’s waterways',

  // Long description (og:description)
  descriptionLong: 'Voices from endangered river communities, carried downstream.',

  // Full sentence used in <title> and social cards
  descriptionFull: 'An online audio station carrying the voices and oral history of people in endangered communities along America’s rivers.',

  // ─── URLs ───────────────────────────────────────────────────────────────────

  siteUrl: 'https://voices.peoplesriverhistory.org',

  // Static social/OG share image — social crawlers need a fixed URL.
  // The actual homepage image rotates dynamically; see config.app.homepageImages.
  ogImage: 'https://voices.peoplesriverhistory.org/img/voices-og-photo.png',

  // ─── Colors ─────────────────────────────────────────────────────────────────
  // CSS-specific brand values (colors, fonts, etc.) live in brand.css, not here.
  // See: AdminClient/src/brand/brand.css (and config/brand.css for backend templates)

  // ─── Email ──────────────────────────────────────────────────────────────────
  // Addresses use the root domain (peoplesriverhistory.org) — DNS MX records
  // are only configured there, not on the voices. subdomain.

  email: {
    // Sender display name used in all outgoing email From: headers
    fromName: 'Voices of River History',

    // Automated system messages (password reset, account actions)
    noreply: 'noreply@peoplesriverhistory.org',

    // Personal welcome messages from Wes
    welcome: 'wes@peoplesriverhistory.org',

    // General enquiries / contact
    contact: 'info@peoplesriverhistory.org',
  },
};

module.exports = brand;
